import React, { useEffect, useState } from "react";
import useGuestWishlist from "./useGuestWishlist";
import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";
import toast from "react-hot-toast";
import WishListCard from "./WishListCard";
import useFetchProduct from "../../adminDashboard/products/useFetchProduct";
import useGuestCart from "../cart/useGuestCart";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function GuestWishlist() {
  // const [addItemId, setAddItemId] = useState(null);
  const [productDetails, setProductDetails] = useState({});
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);

  const {
    guestWishlist,
    removeFromWishlist: removeFromGuestWishlist,
    clearWishlist: clearGuestWishlist,
  } = useGuestWishlist();

  const { addToCart, removeFromCart, isInCart } = useGuestCart();

  const { getOneProductFn } = useFetchProduct();

  const fetchProductDetails = async (productId) => {
    try {
      const product = await getOneProductFn(productId);
      setProductDetails((prev) => ({
        ...prev,
        [productId]: product,
      }));
    } catch (error) {
      console.error("Error fetching product:", error);
      toast.error("Failed to load product details");
    }
  };

  useEffect(() => {
    const fetchAllProductDetails = async () => {
      setIsLoadingProducts(true);
      if (guestWishlist?.length) {
        const promises = guestWishlist.map((item) =>
          fetchProductDetails(item.productId)
        );
        await Promise.all(promises);
      }
      setIsLoadingProducts(false);
    };

    fetchAllProductDetails();
  }, [guestWishlist]);

  const handleRemoveFromWishlist = (productId) => {
    removeFromGuestWishlist(productId);
  };

  const handleClearWishlist = () => {
    clearGuestWishlist();
  };

  const handleCartAction = (productId) => {
    // setAddItemId(productId);
    if (isInCart(productId)) {
      removeFromCart(productId);
    } else {
      // console.log("Adding to cart");
      addToCart({ productId });
    }
  };

  if (isLoadingProducts) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <CustomLoading size="2rem" />
      </div>
    );
  }

  const isEmpty = !guestWishlist?.length;

  return (
    <div className="container py-8">
      <h1 className="text-3xl font-bold mb-8">My Wishlist</h1>

      {isEmpty ? (
        <div className="text-center py-12">
          <h2 className="text-2xl font-semibold text-gray-600 mb-4">
            Your wishlist is empty
          </h2>
          <p className="text-gray-500 mb-6">
            Add items to your wishlist to see them here
          </p>
          <Link
            to="/"
            className="inline-block bg-[#DA0E1A] text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors text-lg"
          >
            Continue Shopping
          </Link>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 justify-center gap-4">
            {guestWishlist?.map((item, index) => {
              const product = productDetails[item.productId];
              return (
                <WishListCard
                  key={index}
                  item={item}
                  isInCart={isInCart}
                  handleCartAction={handleCartAction}
                  product={product}
                  handleRemoveFromWishlist={handleRemoveFromWishlist}
                />
              );
            })}
          </div>

          <div className="mt-8 flex justify-end">
            <button
              onClick={handleClearWishlist}
              className="bg-red-600 hover:bg-red-700 transition-colors rounded-lg py-2 px-4 text-lg text-white flex items-center gap-2"
            >
              Clear Wishlist
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={20}
                height={20}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 6h18" />
                <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
              </svg>
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default GuestWishlist;
